import { tv } from 'tailwind-variants';

import { EntitySection } from './entity-section.component';

import { Skeleton } from '@/components/ui/skeleton.component';
import { Star } from '@/components/ui/star.component';

const titleSkeletonClasses = tv({
  base: ['w-48 h-3'],
});

function TextSkeleton({ className }: { className?: string }) {
  return <Skeleton className={titleSkeletonClasses({ className })} />;
}

export function EntityRatingCardLoading() {
  return (
    <EntitySection>
      <div className="flex items-start gap-6">
        <div className="space-y-3">
          <Skeleton className="w-28 h-28 rounded" />
          <Star rating={0} />

          <TextSkeleton className="h-3 w-32" />
        </div>

        <div className="w-full flex-1">
          <TextSkeleton className="h-3 w-32" />

          <div className="space-y-4 mt-6">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton className="w-full h-2.5 rounded-full" key={i} />
            ))}
          </div>
        </div>
      </div>
    </EntitySection>
  );
}
